import {Capability} from "../formElementCapability";
import {formElementsSchema, baseRestrictions, restrictionSchema} from "./panValidationSchema";
import IFormElementSchema from "./iFormElementSchema";
import TemplateElement from "./templateElement";


export default class PanValidation extends TemplateElement {
  restrictionSchema: object = restrictionSchema;
  formElementsSchema: Array<IFormElementSchema> = formElementsSchema;
  _elementRestrictions: Array<Array<Capability>> = [baseRestrictions];
}